// extracted by mini-css-extract-plugin
export default {"app_container":"app_app_container__i06Ml"};